import React, {useContext} from 'react';
import {StateContext} from '../App';
import {gap} from '../constants';
import LetterSvg from './LetterSvg';

const LetterBox = React.forwardRef(({xpos, ypos, letter, collected, used, className, color}, ref) => {
    const stateContext = useContext(StateContext);
    const {wordColor} = stateContext;

    const letterStyle = {
        top: ypos * gap + 'px',
        left: xpos * gap + 'px',
        backgroundColor: `${collected ? wordColor : used ? color : ''}`,
    };

    return (
        <div
            className={`letter-box${collected ? ' collected' : ''}${used ? ' used' : ''} ${className || ''}`}
            data-xpos={xpos}
            data-ypos={ypos}
            style={letterStyle}
            ref={ref}
        >
            {/* <LetterSvg letter={letter.toLowerCase()} color={collected || used ? 'white' : undefined} /> */}
            {letter}
        </div>
    );
});

export default LetterBox;
